import { lazily } from '@mkmp/core'
import { BasicLayout } from '@/features/layout'

const { OrderMgmt, OrderDetail, OrderAccept } = lazily(() => import('@/features/order'))

/**
 * 用户相关页面
 */
export default [
  {
    id: Symbol('order'),
    path: 'order',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <OrderMgmt />,
        handle: {
          code: 'order'
        }
      }
    ]
  },
  {
    id: Symbol('order-detail'),
    path: 'order/detail',
    element: <OrderDetail />
  },
  {
    id: Symbol('order-accept'),
    path: 'order/accept',
    element: <OrderAccept />
  }
]
